export const withNewLines = (str?: string | null) => {
  return (str || '')
    .split('\\n')
    .reduce(
      (acc, strFragment, i) =>
        acc.length === 0
          ? [strFragment]
          : [...acc, <br key={i} className="hidden md:block" />, strFragment],
      [] as React.ReactNode[],
    )
}

export const stripNewLines = (str?: string | null) => {
  return str?.replace(/\\n/g, ' ')
}
